import { useEffect, useRef, useState, useMemo } from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import classNames from "classnames";

const CustomTabs = ({ tabs, currentValue, onChange }) => {
  const visibleTabs = useMemo(() => tabs.filter((tab) => tab.condition), [tabs]);
  const tabRefs = useRef([]);
  const [indicatorStyle, setIndicatorStyle] = useState({});

  useEffect(() => {
    const index = visibleTabs.findIndex((tab) => tab.value === currentValue);
    const currentTab = tabRefs.current[index];
    if (currentTab) {
      setIndicatorStyle({
        width: currentTab.offsetWidth,
        left: currentTab.offsetLeft,
      });
    }
  }, [currentValue, visibleTabs]);

  return (
    <div style={{ position: "relative", width: "fit-content", margin: "0 auto" }}>
      {/* Custom indicator */}
      <div
        style={{
          position: "absolute",
          height: 45,
          borderRadius: 10,
          backgroundColor: "#021B38",
          zIndex: 0,
          top: 0,
          transition: "all 0.2s ease",
          ...indicatorStyle,
        }}
      />
      <Nav tabs style={{ position: "relative", zIndex: 1, gap: 8, border: "none" }}>
        {visibleTabs.map((tab, index) => (
          <NavItem key={tab.value}>
            <NavLink
              innerRef={(el) => (tabRefs.current[index] = el)}
              className={classNames({ active: currentValue === tab.value })}
              onClick={() => onChange(null, tab.value)}
              style={{
                textTransform: "none",
                minHeight: 45,
                padding: "10px 24px",
                color: "#76a521",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                gap: "0.75rem",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                zIndex: 2,
              }}
            >
              {tab.icon}
              {tab.label}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
    </div>
  );
};

export default CustomTabs;
